import "./lead-generation-block.scss";